import { render, staticRenderFns } from "./InfosetsTableRow.vue?vue&type=template&id=388f68c3&scoped=true&"
import script from "./InfosetsTableRow.vue?vue&type=script&lang=ts&"
export * from "./InfosetsTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetsTableRow.vue?vue&type=style&index=0&id=388f68c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f68c3",
  null
  
)

export default component.exports